import { useSyncExternalStore } from 'react'

import { EntityList } from '@/types/Entity'
import {
  getEntityServerSnapshot,
  getEntitySnapshot,
  LOCALSTORAGE_KEY_ENTITY,
  setEntityValue,
  subscribeEntity,
} from './entityStore'

// API publique inchangee : useEntity / setEntity / getEntityForRoute /
// LOCALSTORAGE_KEY_ENTITY. L'etat n'est plus stocke dans le cache Apollo mais
// dans un store module (lib/hook/entityStore.ts) lu via useSyncExternalStore.

const setEntity = async (value: EntityList): Promise<void> => {
  setEntityValue(value)
}

const useEntity = (): EntityList =>
  useSyncExternalStore(subscribeEntity, getEntitySnapshot, getEntityServerSnapshot)

const getEntityForRoute = async (): Promise<EntityList> => getEntitySnapshot()

export { setEntity, useEntity, getEntityForRoute, LOCALSTORAGE_KEY_ENTITY }
